import { render, staticRenderFns } from "./SortDialog.vue?vue&type=template&id=20c4b84e"
import script from "./SortDialog.vue?vue&type=script&lang=js"
export * from "./SortDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports